// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function TrendUpSoftIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						fillRule="evenodd"
						d="M19.589 8.384a1 1 0 1 0 .824 1.822l5.184-2.343c-.125.405-.255.805-.353 1.054-.521 1.329-1.272 3.061-2.196 4.707-.933 1.662-1.997 3.153-3.12 4.073-1.09.892-2.086 1.144-3.084.729a.91.91 0 0 0-.027-.012c-.92-.394-1.56-1.263-2.42-2.429l-.016-.022c-.785-1.064-1.796-2.432-3.442-2.922a.971.971 0 0 0-.027-.008c-1.562-.452-2.997.122-4.154 1-1.159.88-2.17 2.157-2.99 3.406a30.28 30.28 0 0 0-1.965 3.533 32.684 32.684 0 0 0-.683 1.534c-.223.547-.087 1.19.515 1.425a1 1 0 0 0 1.296-.567c.205-.52.438-1.029.678-1.533.44-.925 1.07-2.135 1.83-3.294.769-1.171 1.633-2.23 2.528-2.91.89-.676 1.676-.884 2.402-.668l.013.004c.9.273 1.545 1.043 2.388 2.187l.143.194C13.65 18.35 14.58 19.622 16 20.24l.027.013c1.94.83 3.73.167 5.166-1.008 1.413-1.157 2.624-2.906 3.598-4.643.985-1.753 1.773-3.577 2.314-4.955.09-.228.218-.54.35-.856l2.219 4.91a1 1 0 1 0 1.822-.823l-3.295-7.29a1 1 0 0 0-1.323-.5l-7.29 3.296Z"
						clipRule="evenodd"
					/>
				</svg>
			}
		</IconContainer>
	);
}
